import { useEffect, useState } from 'react'
import { computeHeroStats, type HeroStats } from '../lib/heroStats'

/**
 * KPIs de las tarjetas del hero. Se calculan de forma determinista a partir de
 * la hora actual (ver `heroStats.ts`) y se refrescan cada `refreshMs` para que
 * "avancen" en vivo a medida que pasa el día. Sincroniza con el reloj (sistema
 * externo), por eso el intervalo — no es estado derivado de props.
 */
export function useHeroStats(refreshMs = 60_000): HeroStats {
  const [stats, setStats] = useState<HeroStats>(() => computeHeroStats(new Date()))

  useEffect(() => {
    const id = setInterval(() => setStats(computeHeroStats(new Date())), refreshMs)
    return () => clearInterval(id)
  }, [refreshMs])

  return stats
}
